import {configureStore} from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './rootSaga';
import apiSlice from "./api/apiSlice";
import searchAndFilterSlice from "./searchAndFilter/searchAndFilterSlice";

const sagaMiddleware = createSagaMiddleware(); // Create a Saga middleware instance, which listens for dispatched actions

const store = configureStore({ // Create a Redux store with the root reducer and Saga middleware
    reducer: { // Combine the reducers for the API and search/filter slices
        api: apiSlice,
        searchFilter: searchAndFilterSlice,
    },
    middleware: (getDefaultMiddleware) => 
        getDefaultMiddleware({thunk: false}).concat(sagaMiddleware), // Add the Saga middleware to the store
});
sagaMiddleware.run(rootSaga); // Start the rootSaga when the store is created

export default store;
